<div class="card card-custom gutter-b card-fit" >
    
    <div class="card-body  mt-0 py-0 px-5"> 
        <div class="row pb-4 pt-4">
        <div class="col-lg-8">
            <div class="d-flex align-items-center gap-3">
                <div class="d-flex align-items-center" >
                    <label class="form-label-sm mb-0 mr-3">Filter by:</label>
                    <div class="btn-group btn-group-toggle" data-toggle="buttons" *ngIf="pet_no > 0">
                        <label class="btn btn-outline-primary btn-sm" [class.active]="filterType === 'pet'" (click)="setFilterType('pet')">
                            <input type="radio" name="filterType" value="pet" [checked]="filterType === 'pet'"> Pet
                        </label>
                        <label class="btn btn-outline-primary btn-sm" [class.active]="filterType === 'client'" (click)="setFilterType('client')">
                            <input type="radio" name="filterType" value="client" [checked]="filterType === 'client'"> Client
                        </label>
                    </div>
                </div>
                <div *ngIf="filterType === 'client'" class=" flex-grow-1 ml-5">
                    <div class="input-group input-group-sm" style="max-width: 200px;">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="fas fa-search"></i>
                            </span>
                        </div>
                        <select class="form-control form-select-sm" id="inputGroupSelect02" name="_pet_no" (change)="onPetChange($event)"
                            [(ngModel)]="searchTerm" required>
                            <option value="">All Pets</option>
                            <option [value]="item.pet_no" *ngFor="let item of petService.pets">
                                {{ item.pet_name }}
                            </option>
                        </select>
                    </div>
                </div>
             
            </div>
        </div>
        <div class="col text-right">
        <button type="button" class="btn btn-success font-weight-bold btn-sm" (click)="add()">
        <!--begin::Svg Icon | path: icons/duotune/general/gen031.svg-->
        <i class="fas fa-plus icon-sm"></i>Add Appointment
        </button>
        </div>
    </div>
    <div class="table-responsive max-h-500px "> 

        <table class="table table-bordered table-sm rounded my-0">
            <thead class="thead-light">
                <tr>
                    <th></th>
                    <th style="width: 20%" *ngIf="filterType === 'client'">Pet</th>  
                    <th style="width: 20%">Appt Date</th> 
                    <th style="width: 15%">Doctor</th>
                    <th style="width: 10%">Time</th>
                    <th style="width: 25%">Appt Procedure</th>
                    <th style="width: 35%">Appointment Note</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngIf="!appointmentService.appts_petsclients || appointmentService.appts_petsclients.length == 0">
                    <td colspan="6">NO EXISTING APPOINTMENT</td>
                </tr>
                <tr *ngFor="let item of appointmentService.appts_petsclients || []" [class.font-weight-bold]="!isAppointmentDatePassed(item.appointment_date)">
                    <td>
                        <button type="button" 
                                class="btn btn-icon btn-sm px-0 py-0"
                                (click)="openApptDetBtn(item.appointment_id)"
                                [class.btn-success]="!isAppointmentDatePassed(item.appointment_date)"
                                [class.btn-secondary]="isAppointmentDatePassed(item.appointment_date)"
                                >
                            <i class="las la-calendar-day icon-lg"></i>
                        </button>

                    </td>
                    <td *ngIf="filterType === 'client'">
                        <span >{{ item.pet_name }}</span>
                    </td>
                    <td>
                        <span >
                            {{ item.appointment_date | date: 'MM/dd/yyyy' }} {{ item.dropoff_time | date: 'hh:mm a' }}
                        </span>
                    </td>
                    <td>
                        <span >{{ item.doctor }}</span>
                    </td>
                    <td>
                        <span >{{ item.doctor_time_needed }} mins</span>
                    </td>
                    <td>
                        <span >{{ item.appt_proc_name }}</span>
                    </td>
                    <td>
                        <span >{{ item.appointment_note }}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</div>

<!-- 
<div class="card-body mt-0 py-0 px-5" >
    <div class="card-toolbar">

        <button type="button" class="btn btn-sm  btn-secondary mr-2 font-weight-bold">
            <i class="fas fa-filter icon-sm"></i>Filter
        </button>

        <button type="button" class="btn btn-sm btn-primary font-weight-bold" (click)="add()">
            <i class="fas fa-plus icon-sm"></i>Add Appointment
        </button>
    </div>
    <span *ngIf="clientService.client_appts.length === 0">No information available</span>
    <div class="table-responsive h-500px">
        <table class="table">
            <thead>
                <tr>
                    <th class="p-0 min-w-150px"></th>
                    <th class="p-0 min-w-120px"></th>
                    <th class="p-0 min-w-100px"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of clientService.client_appts">

                    <td class="pl-0">
                        <span class="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg"
                            (click)="edit(item)">
                            {{ item.appointment_note }}
                        </span>
                        <p>{{ item.doctor_name | uppercase }}</p>
                        <p>{{ item.pet_name }}</p>
                    </td>

                    <td class="text-right">
                        <span class="text-muted font-weight-bold">{{ item.appointment_date }}</span>
                    </td>
                    <td class="text-right pr-0">
                        <button type="button" class="btn btn-icon btn-secondary btn-sm m-1" (click)="edit(item)">
                            <i class="la la-pen"></i>
                        </button>
                        <button type="button" class="btn btn-icon btn-secondary btn-sm btn-hover-danger m-1"
                            (click)="edit(item)">
                            <i class="la la-trash"></i>
                        </button>
                    </td>
                </tr>

            </tbody>
        </table>
    </div>
</div> -->

<!-- <div class="card card-custom gutter-b card-fit" data-card="true" id="kt_card_1">
    <div class="card-header">
        <div class="card-title">
            <h3 class="card-label">Appointments</h3>
        </div>
    </div>
    <div class="card-body  mt-0 py-0 px-5">
    </div>
</div> -->
<style>
    table tr td
    {
        vertical-align: middle;
    }
</style>